














import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
@Component({})
export default class Button extends Vue {
  @Prop({ default: "primary", type: String }) type!: string;
  @Prop() title!: string;
  mode!: string;

  get typeClass() {
    this.mode = this.type;
    const classes = [`button-${this.mode}`];
    return classes;
  }
}
